var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"not_found text_center"},[_c('p',[_vm._v("ページが見つかりません。")]),(!_vm.isLp)?_c('p',[_c('router-link',{staticClass:"decoration_link_arrow_blue",attrs:{"to":{ name: 'Top' }}},[_vm._v("トップページへ戻る")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }